"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventsActions = void 0;
const react_1 = require("react");
const useEventsActions = (childApiRef, currentTrack) => {
    const fetchPoint = (0, react_1.useCallback)(() => {
        var _a;
        (_a = childApiRef === null || childApiRef === void 0 ? void 0 : childApiRef.current) === null || _a === void 0 ? void 0 : _a.call("FETCH_POINT");
    }, []);
    const nextTrack = (0, react_1.useCallback)(() => {
        var _a;
        (_a = childApiRef.current) === null || _a === void 0 ? void 0 : _a.call("NEXT_TRACK");
    }, []);
    const dislike = (0, react_1.useCallback)(() => {
        var _a;
        (_a = childApiRef.current) === null || _a === void 0 ? void 0 : _a.call("DISLIKE", currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.mediafileId);
    }, [currentTrack]);
    const regeneratePlaylist = (0, react_1.useCallback)((switchImmediately = false) => {
        var _a;
        (_a = childApiRef.current) === null || _a === void 0 ? void 0 : _a.call("REGENERATE_PLAYLIST", switchImmediately);
    }, []);
    const getSettings = (0, react_1.useCallback)(() => {
        var _a;
        (_a = childApiRef.current) === null || _a === void 0 ? void 0 : _a.call("GET_SETTINGS");
    }, []);
    const setSetting = (0, react_1.useCallback)((key, value) => {
        var _a;
        (_a = childApiRef.current) === null || _a === void 0 ? void 0 : _a.call("SET_SETTING", { key, value });
    }, []);
    const toggleCaching = (0, react_1.useCallback)((state) => {
        var _a;
        (_a = childApiRef.current) === null || _a === void 0 ? void 0 : _a.call("TOGGLE_CACHING", state);
    }, []);
    const changePlayState = (0, react_1.useCallback)((state) => {
        var _a;
        (_a = childApiRef.current) === null || _a === void 0 ? void 0 : _a.call("SET_PLAY_STATE", state);
    }, []);
    const changeVolume = (0, react_1.useCallback)((nextVolume) => {
        var _a;
        (_a = childApiRef.current) === null || _a === void 0 ? void 0 : _a.call("SET_VOLUME", nextVolume);
    }, []);
    const getGenerationSettings = (0, react_1.useCallback)(() => {
        var _a;
        (_a = childApiRef.current) === null || _a === void 0 ? void 0 : _a.call("GET_GENERATION_SETTINGS");
    }, []);
    return {
        fetchPoint,
        nextTrack,
        dislike,
        regeneratePlaylist,
        getSettings,
        setSetting,
        toggleCaching,
        changePlayState,
        changeVolume,
        getGenerationSettings,
    };
};
exports.useEventsActions = useEventsActions;
//# sourceMappingURL=useEventsActions.js.map